import React from 'react'

export interface Props {
  children?: React.ReactNode
  label?: React.ReactNode
}

// Due to the way how the HTML description list works this component cannot have its own stories/styles and is based on a fragment.
const DescriptionListItem = ({children, label}: Props) => (
  <>
    <dt>{label}</dt>
    <dd>{children}</dd>
  </>
)

export default DescriptionListItem
